module.exports = __webpack_public_path__ + "img/loading.24c3c18a.gif";